export default "__VITE_ASSET__Cj$ZPyVO__"